export enum EImportStep {
  Starting,
  Uploaded,
  Processing,
  Processed,
  PreparingImport,
  ImportingPages,
  Done,
}
